<template>
    <DynamicComponent/>
</template>
<script>
import DynamicComponent from "@/components/DyamicComponent.vue"
import Editor from "@/components/Editor.vue";
import VueFbCustomerChat from 'vue-fb-customer-chat'
import Vue from 'vue'



console.log('chat messeger')

export default {
  components: {
    DynamicComponent 
  },
  name: "HelloWorld",
  props:['idreservation'],
  methods:{
    check() { this.checked = !this.checked; },
    seleziona(soluzione){
      
      this.tab = `tab-${soluzione.id}`
      console.log(this.tab)
    },
    carica_preventivo(idpreve){
      this.loading = true
      console.log("CARICO PRENVENTIVO",this.idreservation)
      this.$store.dispatch("getPreventivo",idpreve)    
      .then(response => {
            console.log(response)
            this.loading = false
        }, error => {
            console.error(error)
        })
    },
    modifica(context,variable){
      this.context = context;
      this.variabile = variable
      console.log(variable)
      this.dialog = true;
    },
    setvalue(){
      console.log("dialog chiuso")
      this.$store.dispatch("updatePreventivo")  
      this.dialog = false   
    }
  },
  mounted(){
    Vue.use(VueFbCustomerChat, {
    page_id: this.$store.state.config.facebook_page_id, //  change 'null' to your Facebook Page ID,
    theme_color: '#333333', // theme color in HEX
    locale: 'en_US', // default 'en_US'
  })

    Vue.use(Editor)
    
    this.carica_preventivo(this.idreservation)

  },
  computed:{
    preventivo(){
      return this.$store.state.preventivo;
    }

  },
  data: () => ({
    checked: false, 
    title: 'Check me',
    dialog:false,
    loading:true,

    tab: null,
    admin:false,
    text:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
    icons: false,
    centered: false,
    grow: false,
    vertical: false,
    prevIcon: false,
    nextIcon: false,
    right: false,
    tabs: 3,
    



  })
};
</script>

